export default {
  title: '会员管理',
  memberList: '会员列表',
  memberLevel: '会员等级',
};
